<template>

    <div v-if="showCookieBar" class="cookie__container">

        <img v-if="versionB" class="cookie__img" src="/img/cartoon/cookie.svg">

        <h2 class="cookie__title">{{ this.computedTitle }}</h2>

        <markdown :blank="true" :text="computedDescription" class="cookie__subtitle"></markdown>

        <button class="btn btn-big btn-green cookie__btn-green" @click="accept">{{ $t('banner_cookies_cta_accept') }}</button>

        <button class="btn btn-big cookie__btn-white" @click="refuse">{{ $t('banner_cookies_cta_refuse') }}</button>

        <button class="btn btn-big cookie__btn-white" @click="manage">{{ $t('banner_cookies_cta_customize') }}</button>

    </div>

</template>

<script>
import Api from '../api'

import Storage from '@/helpers/storage'

import Firebase from '@/modules/firebase'
import Tag from '@/modules/tag'

import Markdown from '@/components/Markdown'

export default {

    name: 'cookie-law',

    components: {Markdown},

    computed: {

        computedTitle: function () {
            return this.versionB
                ? this.$t('banner_cookies_2_title')
                : this.$t('banner_cookies_title')
        },

        computedDescription () {
            return this.versionB
                ? this.$t('banner_cookies_2_description')
                : this.$t('banner_cookies_description')
        }
    },

    data() {
        return {
            showCookieBar: false,
            versionB: false,
            cookies: {}
        }
    },

    async mounted() {

        await this.initCookiesLaw()

        const regexNative = new RegExp('^/fox/native/')
        if (!regexNative.test(this.$route.path)) {

            Firebase.getValue('cookies_version', 'String')
                .then(value => {
                    if (value === 'B') {
                        this.versionB = true
                        Tag.popupGa(this, 'cookies_banner_2')
                    } else {
                        Tag.popupGa(this, 'cookies_banner_1')
                    }
                })

            const cookiesExpired = this.areTheCookiesExpired()
            if (cookiesExpired || !Storage.getItem('cookieLawPreferences')) {

                this.showCookieBar = true
            }
        }
    },

    methods: {

        async initCookiesLaw() {
            return await Api.user.getCookiesList(this)
                .then(cookies => {
                    this.cookies = cookies
                })
        },

        accept() {
            Tag.clickGA(this, 'click_authorize')
            this.cookies.forEach(item => item.active = true)
            Tag.updateCookies(this.cookies)
            this.close()
        },

        refuse() {
            Tag.clickGA(this, 'click_refuse')
            this.cookies.forEach(item => item.active = item.necessary)
            Tag.updateCookies(this.cookies)
            this.close()
        },

        manage() {
            Tag.clickGA(this, 'click_custom')
            this.$emit('manage')
            this.close()

        },

        close() {

            this.showCookieBar = false

        },

        areTheCookiesExpired() {
            const cookieLawPreferences = Storage.getItem('cookieLawPreferences')

            if (cookieLawPreferences) {

                let bool = false
                const maxDate = Date.now() - (1000 * 60 * 60 * 24 * 395) // 13 months

                const cookieLawPreferencesObj = JSON.parse(cookieLawPreferences)

                cookieLawPreferencesObj.forEach(item => {
                    if (parseInt(item.since, 10) < maxDate) {
                        bool = true
                    }
                })

                return bool
            }

            return false
        }
    }

}
</script>

<style lang="scss" scoped>


.cookie {

    &__container {
        position: fixed;
        right: 20px;
        bottom: 20px;
        left: 20px;
        background-color: $white;
        border-radius: 16px;
        box-shadow: 0 8px 32px 0 rgba(17, 17, 26, 0.05), 0 4px 16px 0 rgba(17, 17, 26, 0.1);
        padding: 24px;
        display: flex;
        flex-direction: column;
        z-index: 3;

        &:lang(ar-sa) {
            direction: rtl;
        }
        @media screen and (min-width: $above-mobile-length) {
            left: auto;
            max-width: 280px;
        }
    }

    &__img {
        width: 56px;
        object-fit: contain;
        margin-bottom: 24px;
    }

    &__title {
        font-size: 17px;
        font-weight: 600;
        line-height: 1.41;
        text-align: start;
        color: $charcoal;
    }

    &__subtitle {
        margin-top: 8px;
        font-size: 15px;
        line-height: 1.33;
        text-align: start;
        color: $neutralsMoon;
    }

    &__btn-green {
        margin-top: 24px;
        background-color: $forest;
    }

    &__btn-white {
        margin-top: 8px;
        border: solid 4px $timberwolf;
        color: $charcoal;
    }
}

</style>
